"use client";
import FlightSearchForm from "@/components/frontend-components/flight-folder/search";
import { handleScrollUp } from "@/lib/internalApis";


const FlightPage = () => {
  const flightImg = "/flightimg.webp";

  return (
    <>
    <div
      className="relative w-full text-white"
      style={{
        minHeight: "120vh",
        backgroundColor: "#333",
        backgroundImage: `url(${flightImg})`,
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >

      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50 " />

      <div className="relative z-10">
        <div className=" container mx-auto pb-4 pt-[10%]">
          <div className="text-center h-auto">
            <h1 className="text-2xl md:text-5xl font-bold mb-4 tracking-wide">
              Adding Miles To Your Life
            </h1>
            <p className="text-md mb-6 tracking-wide">
              Discover amazing experiences tailored just for you.
            </p>
            <FlightSearchForm onScroll={handleScrollUp} />
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default FlightPage;